<div class="content-align" [dir]="data.dir">
	<app-form-by-key [formKey]="data.formKey" [submission]="data.submission" [readOnly]="data.viewOnly"
		[enableFormSubmit]="true" (onBeforeSubmit)="beforeSubmit($event)" (onCustomEvent)="customEvent($event)"
		(onFormLoad)="onFormLoad()">
	</app-form-by-key>
</div>